import React from "react";

function Home() {
  return (
    <div>
      <h1 className="text-dark text-center m-5 p-5">The Movie Database</h1>
    </div>
  );
}

export default Home;
